import rollbar from 'rollbar/dist/rollbar.umd.js';

const rollbarConfig = {
  accessToken: 'ad487ceaee7d47e2a9663b601a4fc079',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: (process.env.RAILS_ENV === 'production' || process.env.RAILS_ENV === 'staging'),
  payload: {
    environment: process.env.RAILS_ENV,
  },
  hostSafeList: ['dietplus.jp']
};

const Rollbar = new rollbar(rollbarConfig);

export default Rollbar;
